import classNames from 'classnames';

import styles from './AbsenceLabel.module.scss';

interface Props {
  label?: string;
}

const AbsenceLabel: React.FC<Props> = ({ label = '欠席' }) => (
  <div
    className={classNames(styles.label, {
      [styles.absent]: label === '欠席',
    })}
    data-testid="absenceLabel"
  >
    {label}
  </div>
);
export default AbsenceLabel;
